export default __webpack_public_path__ + "locales/vi/DeleteProfileEverDialog.json?hash=4936b47878e1f694c4799afe1b40e797";